import { ExcellenceCenter } from './ExcellenceCenter.model'; //DESENVOLVIMENTO TEMPORÁRIO

export class ClickSignSigner {
    key: string;
    list_key: string;
    name: string;
    surname: string;
    email: string;
    birthday: string;
    sign_as: string;
    has_documentation: boolean;
    auths: string[];
    documentation: string;
    delivery: string;
    phone_number: string;
    isConsultantInContract = false;
    signerExternal = false;
    type: string;
    group: number;

    excellenceCenters: ExcellenceCenter[] = new Array<ExcellenceCenter>(); //DESENVOLVIMENTO TEMPORÁRIO

    loadDataForConsultantOrInternalUser(r: any) {
        this.key = r.key ? r.key : r.keySigner;
        if (r.list_key)
            this.list_key = r.list_key;
        this.name = r.name && r.surname ? `${r.name} ${r.surname}` : r.name;
        this.documentation = r.documentation ? r.documentation : '';
        this.email = r.fcEmail ? r.fcEmail : r.email;
        this.birthday = r.birthday ? r.birthday : '';
        this.sign_as = r.sign_as ? r.sign_as : 'party';
        this.has_documentation = r.has_documentation ? r.has_documentation : true;
        this.delivery = r.delivery ? r.delivery : 'email';
        this.phone_number = r.phone_number ? r.phone_number : '';
        this.auths = r.auths ? r.auths : ['email'];
        this.type = r.type ? r.type : '';
        this.group = r.group ? r.group : 0;
        //DESENVOLVIMENTO TEMPORÁRIO
        if(r.excellenceCenters) {
            for(let ec of r.excellenceCenters) {
                let excellenceCenter = new ExcellenceCenter();
                excellenceCenter.loadFromServer(ec);
                this.excellenceCenters.push(excellenceCenter);
            }
        }
    }

    loadDataForCompany(r: any) {
        this.key = r.key ? r.key : r.keySigner;
        if (r.list_key)
            this.list_key = r.list_key;
        this.name = r.subscriber ? r.subscriber : '';
        this.documentation = r.documentation ? r.documentation : '';
        this.email = r.subscriberEmail ? r.subscriberEmail : '';
        this.birthday = r.birthday ? r.birthday : '';
        this.sign_as = r.sign_as ? r.sign_as : 'party';
        this.has_documentation = r.has_documentation ? r.has_documentation : false;
        this.delivery = r.delivery ? r.delivery : 'email';
        this.phone_number = r.phone_number ? r.phone_number : '';
        this.auths = r.auths && r.subscriberEmail ? r.auths : ['email'];
        this.type = r.type ? r.type : '';
        this.group = r.group ? r.group : 0;
        //DESENVOLVIMENTO TEMPORÁRIO
        if(r.excellenceCenters) {
            for(let ec of r.excellenceCenters) {
                let excellenceCenter = new ExcellenceCenter();
                excellenceCenter.loadFromServer(ec);
                this.excellenceCenters.push(excellenceCenter);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ClickSignSigner.model.ts